import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import produce from 'immer';
import {_objectIsEqual} from './../../utils/helper';

import {setActiveMultiselectDropdown} from '../../redux/actions';

class PropertiesSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      stageChoice: false,
      topicChoices: [],
      topicValues: [],
      stage: this.props.options,
    };
  }

  componentDidMount() {
    let topicChoices = [];
    let topicValues = [];

    this.props.options.topics.forEach((topic) => {
      topicChoices.push(false);
      topicValues.push(topic.value);
    });

    this.props.selectedValues.forEach((selected) => {
      topicValues.forEach((value, key) => {
        if (value === selected) {
          topicChoices[key] = true;
        }
      });
    });

    this.setState({
      active: this.isAnyTopicsChecked(topicChoices),
      stageChoice: this.isAllTopicsChecked(topicChoices),
      topicChoices,
      topicValues,
      stage: this.props.options,
    });
  }

  componentDidUpdate(prevProps) {
    if (!_objectIsEqual(prevProps.selectedValues, this.props.selectedValues)) {
      const topicChoices = produce([], (draft) => {
        this.state.topicValues.forEach((value, key) => {
          draft[key] = false;
        });

        this.props.selectedValues.forEach((selected) => {
          this.state.topicValues.forEach((value, key) => {
            if (value === selected) {
              draft[key] = true;
            }
          });
        });
      });

      this.setState({
        topicChoices,
      });
    }
  }

  onToggleClicked() {
    this.setState({
      active: !this.state.active,
    });
  }

  onStageCheckBoxChange(e) {
    let topicChoices;

    const checked = e.target.checked;

    if (checked) {
      topicChoices = this.state.stage.topics.map(() => {
        return true;
      });
    } else {
      topicChoices = this.state.stage.topics.map(() => {
        return false;
      });
    }

    const selectedTopics = produce(this.props.selectedValues, (draft) => {
      this.state.topicValues.forEach((value) => {
        if (checked) {
          const index = this.props.selectedValues.indexOf(value);
          if (index === -1) {
            draft.push(value);
          }
        } else {
          const index = this.props.selectedValues.indexOf(value);

          if (index > -1) {
            delete draft[index];
          }
        }
      });
      draft.splice(0, 0);
    });

    this.setState(
      {
        stageChoice: checked,
        topicChoices,
      },
      () => this.sendChoices(selectedTopics),
    );
  }

  onTopicCheckBoxChange(e, key) {
    const topicChoices = [...this.state.topicChoices];
    let selectedTopics = [...this.props.selectedValues];

    // console.log('e.target.checked;', e.target.checked);

    if (e.target.checked) {
      selectedTopics.push(this.state.topicValues[key]);
    } else {
      const index = selectedTopics.indexOf(this.state.topicValues[key]);

      if (index >= 0) {
        selectedTopics.splice(index, 1);
      }
    }

    // console.log('selectedTopics', selectedTopics);

    topicChoices[key] = e.target.checked;

    this.isAllTopicsChecked(topicChoices);

    this.setState({
      topicChoices,
      stageChoice: this.isAllTopicsChecked(topicChoices),
    });

    this.sendChoices(selectedTopics);
  }

  isAnyTopicsChecked(topicChoices) {
    // if (!this.props.selectedValues.length > 0) {
    //   if (this.props.seq === 0) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }

    const checked = topicChoices.find((choice) => {
      return choice === true;
    });

    if (checked === true) {
      return true;
    } else {
      return false;
    }
  }

  isAllTopicsChecked(topicChoices) {
    const checkedAll = topicChoices.find((choice) => {
      return choice === false;
    });

    if (checkedAll === false) {
      return false;
    } else {
      return true;
    }
  }

  sendChoices(selectedTopics) {
    // let payload = [];

    // topicChoices.map((choice, key) => {
    //   if (choice) {
    //     payload.push(this.state.topicValues[key]);
    //   }
    // });

    this.props.onChangeHandler(selectedTopics);
  }

  renderTopics(topics) {
    return topics.map((topic, key) => {
      return (
        <div className="field-wrapper topic hlp-mt-5 hlp-mb-5" key={key}>
          <div className="form-element hlp-flex flex-jcfs flex-aifs">
            <input
              type="checkbox"
              value={topic.value}
              id={`topic${topic.value}`}
              checked={this.state.topicChoices[key]}
              onChange={(e) => this.onTopicCheckBoxChange(e, key)}
            />
            <label htmlFor={`topic${topic.value}`}>{topic.label}</label>
          </div>
        </div>
      );
    });
  }

  render() {
    const {label, value, topics} = this.state.stage;

    return (
      <div>
        <div className="field-wrapper hlp-posr">
          <div className="form-element hlp-flex flex-jcfs flex-aic">
            <input
              type="checkbox"
              value={value}
              id={`stage${value}`}
              checked={this.state.stageChoice}
              onChange={(e) => this.onStageCheckBoxChange(e)}
            />
            <label htmlFor={`stage${value}`}>
              <strong>{label}</strong>
            </label>
          </div>

          <div
            className={`topics-toggle ${this.state.active ? 'active' : ''}`}
            onClick={() => this.onToggleClicked()}
          />
        </div>
        {this.state.active && (
          <div className="hlp-pl-15 hlp-mb-10">{this.renderTopics(topics)}</div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {activeMultiselectDropdown} = state.god;
  return {activeMultiselectDropdown};
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveMultiselectDropdown,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesSelect);
